module.exports = __webpack_public_path__ + "src/img/radioIconOn.2e0c39aa.svg";